import {UserCreate, UserDetails} from './user-create-update';
import {UserListing} from './user-listing';
import {ROUTES} from '../routes';
import {RouteObject} from 'react-router';
import {ProtectedRoute} from '../auth/require-authorization';

export const UserRoutes: RouteObject = {
  path: ROUTES.ADMIN.USERS.path,
  element: <ProtectedRoute role={'Global Admin'} />,
  children: [
    {
      path: ROUTES.ADMIN.USERS.INDEX.path,
      element: <UserListing />,
    },
    {
      path: ROUTES.ADMIN.USERS.CREATE.path,
      element: <UserCreate />,
    },
    {
      path: ROUTES.ADMIN.USERS.DETAIL.path,
      element: <UserDetails />,
    },
  ],
};
